import { LiabilityOwnershipMeta } from '/@/modules/liability/models/meta/LiabilityOwnershipMeta';
import { UnpaidTaxType } from '/@/modules/liability/enums/UnpaidTaxType';

export class UnpaidTaxLiabilityMeta extends LiabilityOwnershipMeta {
  /**
   * @var {string}
   */
  type;

  /**
   * @var {number}
   */
  taxYear;

  /**
   * @var {boolean}
   */
  isConfirmed;

  constructor(model = {}) {
    super(model);

    this.type = model.type;
    this.taxYear = model.taxYear;
    this.isConfirmed = model.isConfirmed;
  }

  /**
   * @returns {string}
   */
  get title() {
    return `${UnpaidTaxType.getByKey(this.type).value} ${this.taxYear}`;
  }

  get isFederal() {
    return this.type === UnpaidTaxType.FEDERAL.key;
  }

  get isStateProvincial() {
    return this.type === UnpaidTaxType.STATE_PROVINCIAL.key;
  }

  get isMunicipalProperty() {
    return this.type === UnpaidTaxType.MUNICIPAL_PROPERTY.key;
  }

  get isMunicipalSchool() {
    return this.type === UnpaidTaxType.MUNICIPAL_SCHOOL.key;
  }

  get isMunicipalMutation() {
    return this.type === UnpaidTaxType.MUNICIPAL_MUTATION.key;
  }
}
